import React from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {Container, Row, Col} from "react-grid-system";
import "./PersonStyle.css";
import Box from "@material-ui/core/Box";
import InfoButton from "./Buttons/InfoButton"
import UserAvatar from './UserAvatar';
import PhoneButton from "./Buttons/PhoneButton"
import WhatsappButton from "./Buttons/WhatsappButton";
import MaleIcon from "./images/male-icon.svg"
import FemaleIcon from "./images/female-icon.svg"
import TempJobIcon from "./images/temp-job.svg"
import RegJobIcon from "./images/reg-job.svg"
import RegTempJobIcons from "./images/reg-temp-job.svg"

const publish_style = {
  fontFamily:"Open Sans Hebrew", 
  fontSize: "12px",
  color: "#c4c4c4",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  padding: "10px 0px"
};

const more_info_style = {
  fontFamily:"Open Sans Hebrew", 
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  justifyContent: "flex-end",
};

function Person(props) {

  console.log("in person", props.attributes)
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    icon: {
      padding: theme.spacing(2),
    },
  }));

  const classes = useStyles();
  
  const personAttributes = props.displayAttributes.map((key) => (
    <Grid item xs={50} key={key}>
      <p style={{ fontFamily: "Open Sans Hebrew" }}>{props.attributes[key]}</p>  
    </Grid>
  ));

  const getPublishDate = () => {
    if (props.attributes["registration_date"] == undefined) {
      return "1.1.2020";
    }
    return props.attributes["registration_date"];
  }

  const getGenderIcon = () => {
    if (props.attributes["stud_gender"] == "male") {
      return MaleIcon;
    } else {
      return FemaleIcon;
    }
  }

  const getCurrentStatus = () => {
    switch(props.attributes["current_occupation"]) {
      case "student":
        return "סטודנט/ית";
      case "service_duty":
        return "בן/בת שירות";
      case "assistance":
        return "סייע/ת";
      case "care_staff_member":
        return "צוות טיפולי";
      case "teacher":
        return "חינוך מיוחד";
      default:
        return "אחר";
    }
  }
  
   const getJobIcon = () => {
    if (isRegJob() && isTempJob()) {
      return RegTempJobIcons;
    }
    if (!isRegJob() && isTempJob()) {
      return TempJobIcon;
    } 
    return RegJobIcon;
  } 

  const isRegJob = () => {
    // if the parent needs a regular job at any day, return true.
    if ((props.attributes["work_on_sunday"]["start_time"] != "") ||
    (props.attributes["work_on_monday"]["start_time"] != "") ||
    (props.attributes["work_on_tuesday"]["start_time"] != "") ||
    (props.attributes["work_on_wednesday"]["start_time"] != "") ||
    (props.attributes["work_on_thursday"]["start_time"] != "") ||
    (props.attributes["work_on_friday"]["start_time"] != "") ||
    (props.attributes["work_on_saturday"]["start_time"] != "")) {
      return true;
    }
    return false;
  }

  const isTempJob = () => {
    // if the parent's temp_job field is defined, return true.
    if (props.attributes["temp_position"]["start_date"] != "") {
      return true;
    }
    return false;
  }

  const getAdditionalInfo = () => {
    // for a student, display gender icon and current status.
    if (props.attributes["type"] == "student") {
      return (
        <div style={{"marginTop":"-12px"}}>
            <div style={{display: "inline-block"}}>
                <img src={getGenderIcon()} />
            </div>
            <div style={{display: "inline-block"}}>
                <p> &nbsp; {props.attributes["age"]}, {getCurrentStatus()} </p>
            </div>
        </div>  
      );
      // for a parent, display the requested job icon.
    } else {
      return (<img src={getJobIcon()} />
      );
    }
  }

  const getRegion = () => {
    // if user type is parent, display the city instead of region.
    if (props.attributes["type"] == "parent") {
      if (props.attributes["city"] != undefined) {
        return props.attributes["city"];
      }
    }
    // if user type is student or a parent without a city attribute, display the region.
    switch (props.attributes["region"]) {
      case "north":
        return "אזור הצפון";
      case "tel-aviv":
        return "מחוז תל אביב";
      case "haifa":
        return "מחוז חיפה";
      case "south":
        return "אזור הדרום";
      case "jerusalem":
        return "מחוז ירושלים";
      case "center":
        return "אזור המרכז";
      default:
        return "אחר";
    }
  }

  return (
    <div classes={classes.root}>
      <Box className="person_box">
        <Container>
          <Row>
            <Col width="15%">
              <Box m={6}/>
              <UserAvatar attributes={props.attributes}/>
            </Col>
            <Col width="45%">
                <Box m={2.2}/>
                {/* display general attributes */}
                {personAttributes}
                {/* display information regarding to type */}
                <Grid item xs={50}>
                  <p style={{ fontFamily: "Open Sans Hebrew" }}>{getRegion()}</p>  
                </Grid>
                {getAdditionalInfo()}
            </Col> 
            <Col width="40%">
                <div>
                  <text style={publish_style}>פורסם: {getPublishDate()}</text>
                </div>
                <Row>  
                  <div className="buttons_style">
                    <WhatsappButton attributes={props.attributes["phone_number"]} city={props.attributes["city"]}/>
                    <Box m={0.2}/>
                    <PhoneButton attributes={props.attributes["phone_number"]}/>
                  </div>    
                </Row>
                <div style={more_info_style}>
                  <InfoButton attributes={props.attributes}></InfoButton>
                </div>
            </Col>      
          </Row>
        </Container>
      </Box>
      <Box m={1.5} />
    </div>
  );
}
export default Person;
